import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import injectSheet from 'react-jss';
import Button from '../../Button';
import FormattedCurrency from '../../FormattedCurrency';
import Typography from '../../Typography';

function OrderSummary({
  classes,
  className,
  event,
  site,
  section,
  submitting,
  ticketsCount,
  subtotalValue,
  totalValue,
  lastStep,
  theme,
}) {
  const {
    data: { button },
    styles,
  } = section;
  const isOnSale = totalValue < subtotalValue;
  const isFree = totalValue === 0 && ticketsCount !== 0;

  return (
    <div className={classNames(classes.root, className)}>
      <div>
        <Typography type="caption" className={classes.count}>
          <FormattedMessage id="ticketsCount" values={{ ticketsCount }} />
        </Typography>
        <Typography
          className={classNames(classes.total, {
            [classes.disabled]: !ticketsCount,
          })}
        >
          {isFree ? (
            <Typography className={classes.freeTicket} component="span">
              <FormattedMessage id="freeTicket" />
            </Typography>
          ) : (
            <FormattedNumber
              value={totalValue}
              // eslint-disable-next-line react/style-prop-object
              style="currency"
              currency="BRL" // TODO: do not hard code this
            />
          )}
          {isOnSale && (
            <span className={classes.discount}>
              <FormattedCurrency value={totalValue - subtotalValue} />
            </span>
          )}
        </Typography>
      </div>
      <Button
        event={event}
        site={site}
        section={section}
        button={button}
        style={{ ...styles.button, backgroundColor: theme.palette.success[500] }}
        className={classes.button}
        componentProps={{ type: 'submit' }}
        loading={submitting}
        disabled={!ticketsCount || submitting}
      >
        <FormattedMessage id={lastStep ? 'finishPayment' : 'continue'} />
      </Button>
    </div>
  );
}

OrderSummary.propTypes = {
  classes: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
  site: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,
  ticketsCount: PropTypes.number.isRequired,
  subtotalValue: PropTypes.number.isRequired,
  totalValue: PropTypes.number.isRequired,
  theme: PropTypes.object.isRequired,
  lastStep: PropTypes.bool,
  className: PropTypes.string,
};

OrderSummary.defaultProps = {
  lastStep: false,
  className: null,
};

const stylesheet = theme => ({
  root: {
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: [[theme.spacing.small, theme.spacing.large]],
    borderTop: [[1, 'solid', theme.palette.common.faintBlack]],
    [theme.breakpoints.down('sm')]: {
      padding: [[theme.spacing.unit, theme.spacing.small]],
    },
  },
  count: {
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  total: {
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  disabled: {
    opacity: 0.3,
  },
  discount: {
    position: 'relative',
    bottom: 3,
    marginLeft: theme.spacing.xsmall,
    backgroundColor: theme.palette.success[500],
    borderRadius: 2,
    padding: [[theme.spacing.xsmall / 2, theme.spacing.xsmall]],
    color: theme.palette.common.white,
    fontSize: 12,
    fontWeight: 'normal',
  },
  freeTicket: {
    color: theme.palette.success[500],
    fontWeight: 'bold',
  },
  button: {
    margin: 0,
  },
});

export default injectSheet(stylesheet)(OrderSummary);



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/OrderSummary/OrderSummary.js